import { withServerSideTranslations } from '@zep/next/server';
import { LandingPageView } from '../../views/home/landing';
const LandingPage = () => {
  return <LandingPageView data-sentry-element="LandingPageView" data-sentry-component="LandingPage" data-sentry-source-file="index.tsx" />;
};
export default LandingPage;
export const getStaticProps = withServerSideTranslations(['home']);